import { Heading, HStack, Stack } from "@chakra-ui/react";
import { DataTable } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

type StatsCardProps = {
  title: string;
  value: number | undefined | null;
};
export const StatsCard = observer(function StatsCard({
  title,
  value,
}: StatsCardProps) {
  return (
    <DataTable.StatCard>
      <Stack>
        <HStack justify="space-between" mb="2">
          <Heading size="sm">{title}</Heading>
        </HStack>
        <Heading size="md">{currency.formatByWorkspace(value ?? 0)}</Heading>
      </Stack>
    </DataTable.StatCard>
  );
});
